<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_modify(null)"
      >新增</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fTitle" label="主题" />
        <el-table-column prop="state" label="是否发布" />
        <el-table-column prop="fUser" label="发布人" />
        <el-table-column
          prop="fDate"
          label="发布时间"
          :formatter="dateFormat"
        />
        <el-table-column prop="fDes" label="发布内容" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button
                type="text"
                size="small"
                @click="_modify(scope.row)"
              >查看</el-button>
            </template>
            <template>
              <ConfirmButton
                v-if="canDel"
                @confirm="_delete(scope.row)"
              >删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import EditForm from './EditForm'
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    EditForm,
    ConfirmButton
  },
  data() {
    return {
      query: {
        fName: null,

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null,
      canAdd: true,
      canEdit: true,
      canDel: true
    }
  },
  mounted() {
    this.refresh()

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '004003002') {
        this.canAdd = val.isGrant
      }
      if (val.key == '004003003') {
        this.canEdit = val.isGrant
      }
      if (val.key == '004003004') {
        this.canDel = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('BasicInformation/Notice/NoticeEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }

          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    _modify: async function(row) {
      const isNew = !row
      if (isNew) {
        this.currentEditItem = {
          fid: null,
          state: null,
          fTitle: null,
          fDes: null
        }
      } else {
        this.currentEditItem = row
      }
      let or
      if (isNew) {
        or = this.canAdd
      } else {
        or = this.canEdit
      }
      const h = this.$createElement
      this.$formDlg({
        title: isNew ? '新增系统消息' : `查看系统消息`,
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData),
        width: '50%',
        readonly: !or
      })
    },
    _delete(row) {
      this.loading = true
      this.$httpPost(`BasicInformation/Notice/DeleteNotice`, {
        fid: row.fid
      }).then(async(res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          this.loading = false
          throw res.message
        }
      })
    },
    postData(modifyType, info) {
      return this.$httpPost(`BasicInformation/Notice/NoticeModify`, {
        datalist: JSON.stringify({
          modifyType,
          info
        })
      }).then(async(res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    getUserName: function() {
      return this.$httpPost(
        'BasicInformation/Distributor/MaxDistributorNu'
      ).then((res) => res.datalist)
    },
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
